var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    d: "M5.648,9.626a.456.456,0,0,1-.287-.1A.44.44,0,0,1,5.2,9.078l.639-3.261-.352.2a.459.459,0,1,1-.457-.8l1.213-.691a.456.456,0,0,1,.5.026.478.478,0,0,1,.183.457L6.261,8.4l.548-.235A.456.456,0,0,1,7.174,9L5.83,9.587A.417.417,0,0,1,5.648,9.626ZM6.939,3.391a.664.664,0,0,0,.2-.457.612.612,0,0,0-.2-.457.664.664,0,0,0-.457-.2.612.612,0,0,0-.457.2.664.664,0,0,0-.2.457.612.612,0,0,0,.2.457.664.664,0,0,0,.457.2A.612.612,0,0,0,6.939,3.391ZM12,6a6,6,0,1,0-6,6A6,6,0,0,0,12,6ZM10.957,6A4.957,4.957,0,1,1,6,1.043,4.954,4.954,0,0,1,10.957,6Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.c1773983be35be2cb1f27de2b0872197.svg";
export { ForwardRef as ReactComponent };